import { useMemo, Fragment } from 'react';
import { ChevronIcon } from '@ui/kit/icons';
import { sequenceTileInput } from '@utils/component-framework';
import { useOpgavekompleksetEntry } from '../../../../../state/hook.entry.js';
import { useTaskContext, TaskContext } from '../../../context.js';
import { ArrowToFacitIcon } from '../../icon.arrow-to-facit.js';
import { SequenceInput } from '../input.content.js';
import { orderInputs } from '../util.order-inputs.js';
import { root, scroller, wrapper, label, container, chevron, arrowToFacit } from './container.facit.style.js';
import { jsx, jsxs } from 'react/jsx-runtime';

function HorisontalFacitContainer(props) {
  const context = useTaskContext();
  const inputEntries = useOpgavekompleksetEntry({
    select: entry => Object.entries(entry?.data.tasks[props.taskEntryKey]?.details ?? {}).map(([key, value]) => {
      const typedValue = sequenceTileInput.entry.asTypeSafe(value);
      if (typedValue) {
        return {
          nodeId: key,
          ...typedValue
        };
      }
    }).filter(it => !!it)
  });
  const userOrderedInputs = useMemo(() => orderInputs(props.task.content, inputEntries), [inputEntries, props.task.content]);
  return /*#__PURE__*/jsx("div", {
    className: root,
    children: /*#__PURE__*/jsxs("div", {
      className: scroller,
      children: [/*#__PURE__*/jsxs("div", {
        className: wrapper,
        "data-theme": "input",
        children: [context === "facit" && /*#__PURE__*/jsx("p", {
          className: label,
          children: "Dit svar"
        }), /*#__PURE__*/jsx("div", {
          className: container,
          children: userOrderedInputs.map(input => /*#__PURE__*/jsxs(Fragment, {
            children: [/*#__PURE__*/jsx(SequenceInput, {
              node: input,
              taskEntryKey: props.taskEntryKey
            }), /*#__PURE__*/jsx(ChevronIcon, {
              className: chevron,
              height: 8,
              strokeWidth: 3
            })]
          }, input.id))
        })]
      }), context === "facit" && /*#__PURE__*/jsxs("div", {
        className: wrapper,
        "data-theme": "facit",
        children: [/*#__PURE__*/jsx(ArrowToFacitIcon, {
          className: arrowToFacit,
          height: 10
        }), /*#__PURE__*/jsx("p", {
          className: label,
          children: "Rigtigt svar"
        }), /*#__PURE__*/jsx("div", {
          className: container,
          children: /*#__PURE__*/jsx(TaskContext.Provider, {
            value: "readonly",
            children: props.task.content.map(input => /*#__PURE__*/jsxs(Fragment, {
              children: [/*#__PURE__*/jsx(SequenceInput, {
                node: input,
                taskEntryKey: props.taskEntryKey
              }), /*#__PURE__*/jsx(ChevronIcon, {
                className: chevron,
                height: 8,
                strokeWidth: 3
              })]
            }, input.id))
          })
        })]
      })]
    })
  });
}

export { HorisontalFacitContainer };
//# sourceMappingURL=container.facit.js.map
